import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase';

export const storageService = {
  async uploadHomeworkFile(homeworkId, studentId, file) {
    const timestamp = Date.now();
    const fileName = `${timestamp}_${file.name}`;
    const storageRef = ref(storage, `homework-submissions/${homeworkId}/${studentId}/${fileName}`);
    
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);
    
    return {
      name: file.name,
      url: downloadURL,
      type: file.type,
      size: file.size
    };
  },

  async uploadMultipleFiles(homeworkId, studentId, files) {
    const uploadPromises = Array.from(files).map(file => 
      this.uploadHomeworkFile(homeworkId, studentId, file)
    );
    return Promise.all(uploadPromises);
  }
};

